var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useCallback, useEffect, useState } from "react";
import styled from "styled-components";
import { RatingStar } from ".";
var RatingWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 6rem;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n"], ["\n  width: 6rem;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n"])));
var RatingBar = function (_a) {
    var _b = _a.isEditable, isEditable = _b === void 0 ? false : _b, rating = _a.rating, onChange = _a.onChange;
    var _c = useState(rating), currentRating = _c[0], setRating = _c[1];
    useEffect(function () {
        setRating(rating);
    }, [rating]);
    var handleClickStar = useCallback(function (value) {
        if (isEditable) {
            setRating(value);
            if (onChange) {
                onChange(value);
            }
        }
    }, [onChange]);
    return (React.createElement(RatingWrapper, null,
        React.createElement(RatingStar, { size: "1rem", value: 1, rating: currentRating, onClick: handleClickStar }),
        React.createElement(RatingStar, { size: "1rem", value: 2, rating: currentRating, onClick: handleClickStar }),
        React.createElement(RatingStar, { size: "1rem", value: 3, rating: currentRating, onClick: handleClickStar }),
        React.createElement(RatingStar, { size: "1rem", value: 4, rating: currentRating, onClick: handleClickStar }),
        React.createElement(RatingStar, { size: "1rem", value: 5, rating: currentRating, onClick: handleClickStar })));
};
export default RatingBar;
var templateObject_1;
